// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"276":"c9152bfc","418":"1dea3a31","445":"1df97a05","516":"4b38f2a2","941":"a549f62a","979":"d08fc05b"}[chunkId] + ".chunk.css";
};